import React, { Ref, useEffect, useRef, useState } from 'react';
import * as S from './styles';
import DropDown, { DropdownOptions } from '../DropDownNew';
import { ActionItemType } from '../../DomainEnums';
import { ItemTypes, Card } from '../../@types/domain';

export type SelectedOption = {
  value: string;
  type: ItemTypes;
};

export type AddActionItemProperties = {
  options: DropdownOptions[];
  actionItems: Card['actionItems'];
  addItem: (data: SelectedOption) => void | undefined | Promise<any>;
  disabled?: boolean;
  isFocused: boolean;
};

const DEFAULT_VALUES: SelectedOption = {
  value: '',
  type: {
    iconUrl: '',
    id: '',
    name: ActionItemType.TEXT_NOTE,
  },
};

function AddActionItem({
  addItem,
  actionItems,
  options,
  disabled = false,
  isFocused,
}: AddActionItemProperties) {
  const inputReference: Ref<HTMLInputElement> = useRef<any>();

  const [value, setValue] = useState<string>(DEFAULT_VALUES.value);
  const [type, setType] = useState(options[0] || DEFAULT_VALUES.type);
  const [error, setError] = useState<Error | null>(null);

  const handleAdd = async (
    event?: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event?.preventDefault();

    const alreadyExist = actionItems.find(
      (actionItem) => actionItem.text === value
    );

    if (alreadyExist) {
      setError(
        new Error(
          'This action item has already been added. Please, try a different description.'
        )
      );
    } else {
      await addItem({ value, type });
      setValue(DEFAULT_VALUES.value);
      setError(null);
      setTimeout(() => {
        inputReference.current?.focus();
      }, 0);
    }
  };

  useEffect(() => {
    if (value === '' && isFocused) {
      inputReference.current?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <S.Wrapper>
        <S.ActionItem error={error}>
          {options && options.length > 0 && (
            <DropDown
              options={options}
              handleOption={setType}
              selectedItem={type}
            />
          )}

          <S.ActivityInput
            ref={inputReference}
            placeholder="+ Add action item"
            value={value}
            disabled={disabled}
            onChange={(event_) => {
              setValue(event_.target.value);
            }}
          />
          <S.ActivityButton type="submit" onClick={handleAdd}>
            Add
          </S.ActivityButton>
        </S.ActionItem>
      </S.Wrapper>
      {error && <S.ErrorText>{error.message}</S.ErrorText>}
    </>
  );
}

export default AddActionItem;
